module.exports = __webpack_public_path__ + "static/media/galerija_2022_0015.5f647e10.jpg";